import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { setReadOnly, setInEdits } from "editor/actions/status";
import { hydrateAndLockItem } from "editor/actions/locking";
import { STATUS } from "config/constants";
import ReadOnlyPanel from "editor/components/ReadOnlyPanel";

class ReadyForEditsContainer extends React.Component {
  constructor() {
    super();

    this.lockAndSetInEdits = this._lockAndSetInEdits.bind(this);
  }

  componentDidMount() {
    if (this.props.form.status === STATUS.READY_FOR_EDITS.slug) {
      this.props.setReadOnly(true);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.form.status === STATUS.READY_FOR_EDITS.slug &&
      !nextProps.status.isReadOnly
    ) {
      this.props.setReadOnly(true);
    }
  }

  _lockAndSetInEdits() {
    return this.props.hydrateAndLockItem(this.props.form.id).then(() => {
      this.props.setInEdits();
    });
  }

  render() {
    return (
      <>
        {this.props.children}
        <ReadOnlyPanel
          isVisible={this.props.form.status === STATUS.READY_FOR_EDITS.slug}
          description="Are you going to edit this?"
          button="Start editing"
          onClick={this.lockAndSetInEdits}
          key="read-only"
        />
        ,
      </>
    );
  }
}

const mapStateToProps = state => ({
  form: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  setReadOnly,
  setInEdits,
  hydrateAndLockItem,
};

ReadyForEditsContainer.propTypes = {
  form: PropTypes.shape({
    status: PropTypes.string,
  }),
  status: PropTypes.shape({
    isReadOnly: PropTypes.bool,
  }),
  hydrateAndLockItem: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadyForEditsContainer);
